import { render } from "./catalog.cattle.io.clusterrepo.vue?vue&type=template&id=4db560ba&scoped=true&ts=true"
import script from "./catalog.cattle.io.clusterrepo.vue?vue&type=script&lang=ts"
export * from "./catalog.cattle.io.clusterrepo.vue?vue&type=script&lang=ts"

import "./catalog.cattle.io.clusterrepo.vue?vue&type=style&index=0&id=4db560ba&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db560ba"]])

export default __exports__